/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional if a 'More Info' link or a Appstore link should be displayed
 * @export
 * @interface MeInitializeResponseDataButton
 */
export interface MeInitializeResponseDataButton {
    /**
     * 
     * @type {string}
     * @memberof MeInitializeResponseDataButton
     */
    link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeInitializeResponseDataButton
     */
    title?: string | null;
}

/**
 * Check if a given object implements the MeInitializeResponseDataButton interface.
 */
export function instanceOfMeInitializeResponseDataButton(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MeInitializeResponseDataButtonFromJSON(json: any): MeInitializeResponseDataButton {
    return MeInitializeResponseDataButtonFromJSONTyped(json, false);
}

export function MeInitializeResponseDataButtonFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeInitializeResponseDataButton {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'link': !exists(json, 'link') ? undefined : json['link'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function MeInitializeResponseDataButtonToJSON(value?: MeInitializeResponseDataButton | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'link': value.link,
        'title': value.title,
    };
}

